import * as React from "react";
const IconFisAvailable = () => (
  //   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="icon" viewBox="0 0 20 20">
  //     <path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z" />
  //   </svg>

  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" id="FISAvailable">
    <circle
      cx="7"
      cy="7"
      r="7"
      fill="#44825E"
      //   style="fill:#44825E;fill:color(display-p3 0.2667 0.5098 0.3686);fill-opacity:1;"
    ></circle>
    <path
      d="M10.8508 4.10826C11.0343 4.26551 11.0508 4.5364 10.8877 4.7133L6.147 9.85616C6.06266 9.94765 5.94177 10 5.81482 10C5.68787 10 5.56698 9.94765 5.48263 9.85616L3.11227 7.28473C2.94919 7.10782 2.96572 6.83693 3.14918 6.67968C3.33263 6.52243 3.61356 6.53837 3.77663 6.71528L5.81482 8.92634L10.2234 4.14385C10.3864 3.96694 10.6674 3.95101 10.8508 4.10826Z"
      fill="white"
      //   style="fill:white;fill-opacity:1;"
    ></path>
  </svg>
);
export default IconFisAvailable;
